import React from 'react';

type AnimateSpinnerType = {
  customClasses?: string;
  sizeClasses?: string;
};

const AnimateSpinner = ({
  customClasses = '',
  sizeClasses = 'h-6 w-6'
}: AnimateSpinnerType) => (
  <div
    data-testid="loading-spinner"
    className={`${customClasses} animate-spin-slow ease-linear rounded-full border-4 border-t-4 border-gray-200 border-t-[#87deff] top-2 right-2 ${sizeClasses}`}
  />
);

export default AnimateSpinner;
